import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import {
  clearSuperLollipopWinStreak,
  increaseSuperLollipopWinStreak,
} from './superLollipop.modifiers';
import {
  getSuperLollipopWinStreak,
  getSuperLollipopWinStreakRequired,
} from './superLollipop.getters';

export const superLollipopCheats = createActions({
  cheat_resetSuperLollipop: action((state) => {
    state.superLollipop = undefined;
  }),

  cheat_increaseSuperLollipopWinStreak: action((state) => {
    increaseSuperLollipopWinStreak(state);
  }),

  cheat_increaseSuperLollipopWinStreakToMax: action((state) => {
    while (
      getSuperLollipopWinStreak(state) <
      getSuperLollipopWinStreakRequired(state)
    ) {
      increaseSuperLollipopWinStreak(state);
    }
  }),

  cheat_clearSuperLollipopWinStreak: action((state) => {
    clearSuperLollipopWinStreak(state);
  }),

  cheat_simulateSuperLollipopAdminRecovery: action(
    (state, streak: number, api) => {
      state.admin.push({
        reason: 'Super Lollipop Streak Recovery',
        claimed: false,
        timestamp: api.date.now(),
        superLollipopStreak: streak,
      });
    },
  ),
});
